/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteApiV1BoardsIdAssetsAssetIdParams,
  GetApiV1BoardsIdAssetsParams,
  GetApiV1BoardsIdParams,
  GetApiV1BoardsParams,
  GetApiV1BoardsSharedShareIdAssetsParams,
  GetBoardAllAssetsResponse,
  GetBoardAssetsResponse,
  GetBoardResponse,
  GetBoardsResponse,
  GetSharedBoardAssetsResponse,
  GetSharedBoardResponse,
  PatchBoardRequestBody,
  PostBoardRequestBody,
  PostBoardResponse,
  ProblemDetails,
  PutApiV1BoardsIdAssetsAssetIdParams,
  PutBoardAssetRequestBody
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiV1Boards = (
    postBoardRequestBodyNull: PostBoardRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<PostBoardResponse | null>(
      {url: `/api/v1/boards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBoardRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1BoardsMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Boards>>, TError,{data: PostBoardRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1Boards>>, TError,{data: PostBoardRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1Boards'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1Boards>>, {data: PostBoardRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1Boards(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1BoardsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1Boards>>>
    export type PostApiV1BoardsMutationBody = PostBoardRequestBody | null
    export type PostApiV1BoardsMutationError = ProblemDetails | null

    export const usePostApiV1Boards = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1Boards>>, TError,{data: PostBoardRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1Boards>>,
        TError,
        {data: PostBoardRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1BoardsMutationOptions(options), queryClient);
    }
    export const getApiV1Boards = (
    params: GetApiV1BoardsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetBoardsResponse | null>(
      {url: `/api/v1/boards`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1BoardsInfiniteQueryKey = (params?: GetApiV1BoardsParams,) => {
    return [
    'infinite', `/api/v1/boards`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiV1BoardsQueryKey = (params?: GetApiV1BoardsParams,) => {
    return [
    `/api/v1/boards`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1BoardsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiV1Boards>>, GetApiV1BoardsParams['PageNumber']>, TError = ProblemDetails | null>(params: GetApiV1BoardsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData, QueryKey, GetApiV1BoardsParams['PageNumber']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Boards>>, QueryKey, GetApiV1BoardsParams['PageNumber']> = ({ signal, pageParam }) => getApiV1Boards({...params, 'PageNumber': pageParam ?? params?.['PageNumber']}, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData, QueryKey, GetApiV1BoardsParams['PageNumber']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Boards>>>
export type GetApiV1BoardsInfiniteQueryError = ProblemDetails | null


export function useGetApiV1BoardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1Boards>>, GetApiV1BoardsParams['PageNumber']>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData, QueryKey, GetApiV1BoardsParams['PageNumber']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Boards>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Boards>>, QueryKey
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1Boards>>, GetApiV1BoardsParams['PageNumber']>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData, QueryKey, GetApiV1BoardsParams['PageNumber']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Boards>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Boards>>, QueryKey
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1Boards>>, GetApiV1BoardsParams['PageNumber']>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData, QueryKey, GetApiV1BoardsParams['PageNumber']>>, }
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1Boards>>, GetApiV1BoardsParams['PageNumber']>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData, QueryKey, GetApiV1BoardsParams['PageNumber']>>, }
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiV1BoardsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Boards>>, TError = ProblemDetails | null>(params: GetApiV1BoardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Boards>>> = ({ signal }) => getApiV1Boards(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Boards>>>
export type GetApiV1BoardsQueryError = ProblemDetails | null


export function useGetApiV1Boards<TData = Awaited<ReturnType<typeof getApiV1Boards>>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Boards>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Boards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Boards<TData = Awaited<ReturnType<typeof getApiV1Boards>>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Boards>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Boards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Boards<TData = Awaited<ReturnType<typeof getApiV1Boards>>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Boards<TData = Awaited<ReturnType<typeof getApiV1Boards>>, TError = ProblemDetails | null>(
 params: GetApiV1BoardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Boards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1BoardsId = (
    id: number,
    params?: GetApiV1BoardsIdParams,
 signal?: AbortSignal
) => {


      return apiClient<GetBoardResponse | null>(
      {url: `/api/v1/boards/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1BoardsIdQueryKey = (id: number,
    params?: GetApiV1BoardsIdParams,) => {
    return [
    `/api/v1/boards/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1BoardsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1BoardsId>>, TError = ProblemDetails | null>(id: number,
    params?: GetApiV1BoardsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsIdQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsId>>> = ({ signal }) => getApiV1BoardsId(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsId>>>
export type GetApiV1BoardsIdQueryError = ProblemDetails | null


export function useGetApiV1BoardsId<TData = Awaited<ReturnType<typeof getApiV1BoardsId>>, TError = ProblemDetails | null>(
 id: number,
    params: undefined |  GetApiV1BoardsIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsId<TData = Awaited<ReturnType<typeof getApiV1BoardsId>>, TError = ProblemDetails | null>(
 id: number,
    params?: GetApiV1BoardsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsId<TData = Awaited<ReturnType<typeof getApiV1BoardsId>>, TError = ProblemDetails | null>(
 id: number,
    params?: GetApiV1BoardsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsId<TData = Awaited<ReturnType<typeof getApiV1BoardsId>>, TError = ProblemDetails | null>(
 id: number,
    params?: GetApiV1BoardsIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiV1BoardsId = (
    id: number,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/boards/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiV1BoardsIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1BoardsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1BoardsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteApiV1BoardsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1BoardsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiV1BoardsId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1BoardsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1BoardsId>>>

    export type DeleteApiV1BoardsIdMutationError = ProblemDetails | null

    export const useDeleteApiV1BoardsId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1BoardsId>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1BoardsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteApiV1BoardsIdMutationOptions(options), queryClient);
    }
    export const patchApiV1BoardsId = (
    id: number,
    patchBoardRequestBodyNull: PatchBoardRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/boards/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchBoardRequestBodyNull, signal
    },
      );
    }




export const getPatchApiV1BoardsIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1BoardsId>>, TError,{id: number;data: PatchBoardRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV1BoardsId>>, TError,{id: number;data: PatchBoardRequestBody | null}, TContext> => {

const mutationKey = ['patchApiV1BoardsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV1BoardsId>>, {id: number;data: PatchBoardRequestBody | null}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiV1BoardsId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV1BoardsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV1BoardsId>>>
    export type PatchApiV1BoardsIdMutationBody = PatchBoardRequestBody | null
    export type PatchApiV1BoardsIdMutationError = ProblemDetails | null

    export const usePatchApiV1BoardsId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV1BoardsId>>, TError,{id: number;data: PatchBoardRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV1BoardsId>>,
        TError,
        {id: number;data: PatchBoardRequestBody | null},
        TContext
      > => {
      return useMutation(getPatchApiV1BoardsIdMutationOptions(options), queryClient);
    }
    export const putApiV1BoardsIdAssetsAssetId = (
    id: number,
    assetId: number,
    params: PutApiV1BoardsIdAssetsAssetIdParams,
    putBoardAssetRequestBodyNull?: PutBoardAssetRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/boards/${id}/assets/${assetId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putBoardAssetRequestBodyNull,
        params, signal
    },
      );
    }




export const getPutApiV1BoardsIdAssetsAssetIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1BoardsIdAssetsAssetId>>, TError,{id: number;assetId: number;params: PutApiV1BoardsIdAssetsAssetIdParams;data?: PutBoardAssetRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1BoardsIdAssetsAssetId>>, TError,{id: number;assetId: number;params: PutApiV1BoardsIdAssetsAssetIdParams;data?: PutBoardAssetRequestBody | null}, TContext> => {

const mutationKey = ['putApiV1BoardsIdAssetsAssetId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1BoardsIdAssetsAssetId>>, {id: number;assetId: number;params: PutApiV1BoardsIdAssetsAssetIdParams;data?: PutBoardAssetRequestBody | null}> = (props) => {
          const {id,assetId,params,data} = props ?? {};

          return  putApiV1BoardsIdAssetsAssetId(id,assetId,params,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1BoardsIdAssetsAssetIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1BoardsIdAssetsAssetId>>>
    export type PutApiV1BoardsIdAssetsAssetIdMutationBody = PutBoardAssetRequestBody | null | undefined
    export type PutApiV1BoardsIdAssetsAssetIdMutationError = ProblemDetails | null

    export const usePutApiV1BoardsIdAssetsAssetId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1BoardsIdAssetsAssetId>>, TError,{id: number;assetId: number;params: PutApiV1BoardsIdAssetsAssetIdParams;data?: PutBoardAssetRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1BoardsIdAssetsAssetId>>,
        TError,
        {id: number;assetId: number;params: PutApiV1BoardsIdAssetsAssetIdParams;data?: PutBoardAssetRequestBody | null},
        TContext
      > => {
      return useMutation(getPutApiV1BoardsIdAssetsAssetIdMutationOptions(options), queryClient);
    }
    export const deleteApiV1BoardsIdAssetsAssetId = (
    id: number,
    assetId: number,
    params?: DeleteApiV1BoardsIdAssetsAssetIdParams,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/boards/${id}/assets/${assetId}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiV1BoardsIdAssetsAssetIdMutationOptions = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1BoardsIdAssetsAssetId>>, TError,{id: number;assetId: number;params?: DeleteApiV1BoardsIdAssetsAssetIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1BoardsIdAssetsAssetId>>, TError,{id: number;assetId: number;params?: DeleteApiV1BoardsIdAssetsAssetIdParams}, TContext> => {

const mutationKey = ['deleteApiV1BoardsIdAssetsAssetId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV1BoardsIdAssetsAssetId>>, {id: number;assetId: number;params?: DeleteApiV1BoardsIdAssetsAssetIdParams}> = (props) => {
          const {id,assetId,params} = props ?? {};

          return  deleteApiV1BoardsIdAssetsAssetId(id,assetId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV1BoardsIdAssetsAssetIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV1BoardsIdAssetsAssetId>>>

    export type DeleteApiV1BoardsIdAssetsAssetIdMutationError = ProblemDetails | null

    export const useDeleteApiV1BoardsIdAssetsAssetId = <TError = ProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV1BoardsIdAssetsAssetId>>, TError,{id: number;assetId: number;params?: DeleteApiV1BoardsIdAssetsAssetIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV1BoardsIdAssetsAssetId>>,
        TError,
        {id: number;assetId: number;params?: DeleteApiV1BoardsIdAssetsAssetIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiV1BoardsIdAssetsAssetIdMutationOptions(options), queryClient);
    }
    export const getApiV1BoardsIdAssets = (
    id: number,
    params: GetApiV1BoardsIdAssetsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetBoardAssetsResponse | null>(
      {url: `/api/v1/boards/${id}/assets`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1BoardsIdAssetsInfiniteQueryKey = (id: number,
    params?: GetApiV1BoardsIdAssetsParams,) => {
    return [
    'infinite', `/api/v1/boards/${id}/assets`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiV1BoardsIdAssetsQueryKey = (id: number,
    params?: GetApiV1BoardsIdAssetsParams,) => {
    return [
    `/api/v1/boards/${id}/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1BoardsIdAssetsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, GetApiV1BoardsIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsIdAssetsInfiniteQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']> = ({ signal, pageParam }) => getApiV1BoardsIdAssets(id,{...params, 'PageNumber': pageParam ?? params?.['PageNumber']}, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsIdAssetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>>
export type GetApiV1BoardsIdAssetsInfiniteQueryError = ProblemDetails | null


export function useGetApiV1BoardsIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, GetApiV1BoardsIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, QueryKey
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, GetApiV1BoardsIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, QueryKey
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, GetApiV1BoardsIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']>>, }
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, GetApiV1BoardsIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsIdAssetsParams['PageNumber']>>, }
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsIdAssetsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiV1BoardsIdAssetsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError = ProblemDetails | null>(id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsIdAssetsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>> = ({ signal }) => getApiV1BoardsIdAssets(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsIdAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>>
export type GetApiV1BoardsIdAssetsQueryError = ProblemDetails | null


export function useGetApiV1BoardsIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError = ProblemDetails | null>(
 id: number,
    params: GetApiV1BoardsIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsIdAssets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsIdAssetsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1BoardsAssets = (

 signal?: AbortSignal
) => {


      return apiClient<GetBoardAllAssetsResponse | null>(
      {url: `/api/v1/boards/assets`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1BoardsAssetsQueryKey = () => {
    return [
    `/api/v1/boards/assets`
    ] as const;
    }


export const getGetApiV1BoardsAssetsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError = ProblemDetails | null>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsAssetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsAssets>>> = ({ signal }) => getApiV1BoardsAssets(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsAssets>>>
export type GetApiV1BoardsAssetsQueryError = ProblemDetails | null


export function useGetApiV1BoardsAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError = ProblemDetails | null>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsAssets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsAssets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError = ProblemDetails | null>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsAssets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsAssetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1BoardsSharedShareId = (
    shareId: string,
 signal?: AbortSignal
) => {


      return apiClient<GetSharedBoardResponse | null>(
      {url: `/api/v1/boards/shared/${shareId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiV1BoardsSharedShareIdQueryKey = (shareId: string,) => {
    return [
    `/api/v1/boards/shared/${shareId}`
    ] as const;
    }


export const getGetApiV1BoardsSharedShareIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError = ProblemDetails | null>(shareId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsSharedShareIdQueryKey(shareId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>> = ({ signal }) => getApiV1BoardsSharedShareId(shareId, signal);





   return  { queryKey, queryFn, enabled: shareId !== null && shareId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsSharedShareIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>>
export type GetApiV1BoardsSharedShareIdQueryError = ProblemDetails | null


export function useGetApiV1BoardsSharedShareId<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError = ProblemDetails | null>(
 shareId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsSharedShareId<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError = ProblemDetails | null>(
 shareId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsSharedShareId<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError = ProblemDetails | null>(
 shareId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsSharedShareId<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError = ProblemDetails | null>(
 shareId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsSharedShareIdQueryOptions(shareId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1BoardsSharedShareIdAssets = (
    shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams,
 signal?: AbortSignal
) => {


      return apiClient<GetSharedBoardAssetsResponse | null>(
      {url: `/api/v1/boards/shared/${shareId}/assets`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1BoardsSharedShareIdAssetsInfiniteQueryKey = (shareId: string,
    params?: GetApiV1BoardsSharedShareIdAssetsParams,) => {
    return [
    'infinite', `/api/v1/boards/shared/${shareId}/assets`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiV1BoardsSharedShareIdAssetsQueryKey = (shareId: string,
    params?: GetApiV1BoardsSharedShareIdAssetsParams,) => {
    return [
    `/api/v1/boards/shared/${shareId}/assets`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1BoardsSharedShareIdAssetsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsSharedShareIdAssetsInfiniteQueryKey(shareId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']> = ({ signal, pageParam }) => getApiV1BoardsSharedShareIdAssets(shareId,{...params, 'PageNumber': pageParam ?? params?.['PageNumber']}, signal);





   return  { queryKey, queryFn, enabled: shareId !== null && shareId !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsSharedShareIdAssetsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>>
export type GetApiV1BoardsSharedShareIdAssetsInfiniteQueryError = ProblemDetails | null


export function useGetApiV1BoardsSharedShareIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, QueryKey
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsSharedShareIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, QueryKey
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsSharedShareIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>>, }
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsSharedShareIdAssetsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData, QueryKey, GetApiV1BoardsSharedShareIdAssetsParams['PageNumber']>>, }
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsSharedShareIdAssetsInfiniteQueryOptions(shareId,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiV1BoardsSharedShareIdAssetsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError = ProblemDetails | null>(shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BoardsSharedShareIdAssetsQueryKey(shareId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>> = ({ signal }) => getApiV1BoardsSharedShareIdAssets(shareId,params, signal);





   return  { queryKey, queryFn, enabled: shareId !== null && shareId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BoardsSharedShareIdAssetsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>>
export type GetApiV1BoardsSharedShareIdAssetsQueryError = ProblemDetails | null


export function useGetApiV1BoardsSharedShareIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsSharedShareIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>,
          TError,
          Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1BoardsSharedShareIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1BoardsSharedShareIdAssets<TData = Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError = ProblemDetails | null>(
 shareId: string,
    params: GetApiV1BoardsSharedShareIdAssetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1BoardsSharedShareIdAssets>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BoardsSharedShareIdAssetsQueryOptions(shareId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






